/**
 * Integration settings page component for lite home navigation
 */

import { IntegrationSettings } from "@components/Integrations";

interface IntegrationSettingsPageProps {
  onExit?: () => void;
}

const IntegrationSettingsPage: React.FC<IntegrationSettingsPageProps> = () => {
  return <IntegrationSettings />;
};

export default IntegrationSettingsPage;
